import { AuthBackground } from '@/components/AuthBackground';

import { PartnerSignupHeader } from './components/PartnerSignupHeader';
import { PartnerSignupForm } from './components/PartnerSignupForm';
import { usePartnerSignup } from './hooks/usePartnerSignup';
import { PartnerViewerSignupSuccess } from '@/components/PartnerViewerSignupSuccess';
import { SignupInvitationChecking } from '@/components/SignupInvitationChecking';
import { SignupInvitationInvalid } from '@/components/SignupInvitationInvalid';
import { SignupInvitationUnavailable } from '@/components/SignupInvitationUnavailable';

export default function PartnerSignup() {
  const {
    form,
    password,
    isSubmitting,
    emailFromUrl,
    partnerViewerComplete,
    onSubmit,
    invitation,
  } = usePartnerSignup();

  if (partnerViewerComplete) {
    return <PartnerViewerSignupSuccess />;
  }

  return (
    <div className="min-h-screen bg-highlight flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative">
      {!invitation.isChecking && !invitation.isUnavailable && <AuthBackground />}
      <div className="relative z-10">
        {invitation.isChecking ? (
          <SignupInvitationChecking />
        ) : invitation.isUnavailable ? (
          <SignupInvitationUnavailable
            forgotPasswordHref={
              invitation.emailFromUrl
                ? `/forgot-password?email=${encodeURIComponent(invitation.emailFromUrl)}`
                : '/forgot-password'
            }
          />
        ) : invitation.isInvalid ? (
          <SignupInvitationInvalid
            emailFromUrl={invitation.emailFromUrl}
            isResending={invitation.isResending}
            resendSent={invitation.resendSent}
            onResend={invitation.resendInvitation}
          />
        ) : (
          <div className="bg-white rounded-lg border p-6 flex flex-col w-full sm:w-96">
            <PartnerSignupHeader />
            <PartnerSignupForm
              form={form}
              password={password}
              isSubmitting={isSubmitting}
              emailFromUrl={emailFromUrl}
              onSubmit={onSubmit}
            />
          </div>
        )}
      </div>
    </div>
  );
}
